import Component from '../core/Component'
import { toggleClass } from '../utils/dom'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import EventBus from '../core/EventBus'
import support from '../utils/BrowserSupport'
import Scroll, { disableScrolling, enableScrolling } from '../services/Scroll'

const STATES = {
    SUBNAV_ACTIVE: 'is-subnavActive',
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible',
}

export default class NavMobile extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            blocks: [],
            items: [],
            buttons: []
        }

        this.enquireHandler = {
            match: this.attach,
            unmatch: this.detach
        }

        this.isMobile = false

        this.openTime = Date.now()
    }

    prepare() {
        this.blocks = Object.fromEntries(this.ref.blocks.map(element => [element.dataset.id, element]))
        this.nav = this.element.parentNode
        this.nav.addEventListener(support.transitionEnd, event => {
            if (event.target !== this.nav) {
                return
            }

            if (this.nav.classList.contains(STATES.ACTIVE)) {
                document.addEventListener('click', this.handleOuterClick)
            }

            if (!this.nav.classList.contains(STATES.ACTIVE)) {
                this.nav.classList.remove(STATES.VISIBLE)
                this.nav.classList.remove(STATES.SUBNAV_ACTIVE)
                EventBus.emit('mobilenav:afterclose')
            }
        })
        enquire.register(queries.mediumMax, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.mediumMax, this.enquireHandler)
    }

    attach = () => {
        this.element.addEventListener('click', this.handleClick)
    }

    detach = () => {
        this.close()
        this.element.removeEventListener('click', this.handleClick)
        this.ref.blocks.forEach(element => element.classList.remove(STATES.ACTIVE))
        this.nav.classList.remove(STATES.SUBNAV_ACTIVE)
        this.nav.classList.remove(STATES.ACTIVE)
        this.nav.classList.remove(STATES.VISIBLE)
        document.removeEventListener('keyup', this.handleKeyUp)
    }

    handleClick = event => {
        const toggle = event.target.closest('[data-ref="toggle"]')
        if (toggle) {
            this.handleToggleClick(event)
            return
        } else if (event.defaultPrevented) {
            return
        }

        if (event.target.closest('a')) {
            this.close()
        }
    }

    handleToggleClick = event => {
        event.preventDefault()

        if (event.target.dataset.rel) {
            event.stopPropagation()
            this.show(event.target.dataset.rel)
        } else {
            this.hide()
        }
    }

    handleOuterClick = event => {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    handleKeyUp = event => {
        if (event.key === 'Escape') {
            this.close()
        }
    }

    show(id) {
        if (!(id in this.blocks)) {
            return
        }
        this.ref.blocks.forEach(element => toggleClass(element, STATES.ACTIVE, element.dataset.id === id))
        this.nav.classList.add(STATES.SUBNAV_ACTIVE)
    }

    hide() {
        this.nav.classList.remove(STATES.SUBNAV_ACTIVE)
    }

    toggle() {
        if (this.nav.classList.contains(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.nav.classList.add(STATES.VISIBLE)
        this.nav.offsetWidth
        this.nav.classList.add(STATES.ACTIVE)
        this.emit('open')
        EventBus.emit('mobilenav:open')
        disableScrolling()
        document.addEventListener('keyup', this.handleKeyUp)
    }

    close() {
        this.nav.classList.remove(STATES.ACTIVE)
        this.nav.removeAttribute('style')
        document.removeEventListener('click', this.handleOuterClick)
        document.removeEventListener('keyup', this.handleKeyUp)
        this.emit('close')
        EventBus.emit('mobilenav:close')
        enableScrolling()
    }
}
